<template>
  <div v-if="m">
    <section class="sd-kpis">
      <sd-kpi-card v-for="k in m.kpis" :key="k.lbl" :label="k.lbl" :icon="k.icon" :value="k.v" :unit="k.unit" :color="k.color" :delta="k.delta" :delta-unit="k.deltaUnit" :footnote="k.ft" />
    </section>

    <section class="sd-card exhero">
      <div class="exh-main">
        <div class="exh-lbl">{{ t('ex_satlbl') }} · <span class="num-ltr">{{ m.LY.year }}</span></div>
        <div class="exh-num num-ltr">{{ m.LY.satPct }}%</div>
        <div class="exh-sub">
          <template v-if="m.delta != null"><sd-delta-chip :d="m.delta" :unit="' ' + t('ex_pts')" style="font-size:12.5px" /><span class="exh-cap">{{ t('ex_vs') }} {{ m.PY.year }}</span></template>
          <sd-star-pill :score="m.score" />
        </div>
        <div><sd-spark-line :values="m.yr.map(y => y.satPct)" :w="170" :h="36" /></div>
        <div class="exh-cap">{{ t('ex_rated', { n: fmt(m.stat.total) }) }}</div>
      </div>
      <div class="exh-div" />
      <div class="exh-brief">
        <h3>{{ t('ex_brief') }}</h3>
        <sd-insight-list :items="m.brief" @navigate="$emit('navigate', $event)" />
      </div>
    </section>

    <section class="sd-grid" style="margin-top:18px">
      <div class="sd-card c7">
        <div class="head"><div><h3>{{ t('c_ytrend') }}</h3><p class="hint">{{ t('c_ytrend_h') }}</p></div></div>
        <sd-line-chart :series="trendSeries" :years="trendYears" :lo="25" :hi="65" labels emph-last emph-color="var(--sd-pos-2)" />
      </div>
      <div class="sd-card c5">
        <div class="head"><div><h3>{{ t('ex_regions') }}</h3><p class="hint">{{ t('ex_regions_h', { y: m.LY.year }) }}</p></div></div>
        <sd-meter-rows :items="regionRows" :other-text="t('ex_othern', { n: m.regs.length - 6 })" />
      </div>
    </section>

    <template v-if="sh">
      <div class="exst-h">{{ t('ex_strat') }}</div>
      <section class="exstrat">
        <a class="sd-card exst" @click.prevent="$emit('navigate', { name: 'strategic' })">
          <span class="big num-ltr" style="color:var(--sd-pos-2)">{{ sh.h.overall.pos }}%</span>
          <span><div class="lbl">{{ t('st_k_house') }}</div><div class="cap"><sd-delta-chip :d="sh.hDelta" /> {{ sh.houseFt }}</div></span>
          <span class="go">{{ t('ex_more') }}</span>
        </a>
        <a class="sd-card exst" @click.prevent="$emit('navigate', { name: 'strategic' })">
          <span class="big num-ltr" :style="{color: stC(sh.mL.pos)}">{{ sh.mL.pos }}%</span>
          <span><div class="lbl">{{ t('st_k_muni') }}</div><div class="cap"><sd-delta-chip :d="sh.mDelta" /> {{ sh.muniFt }} · {{ t('st_k_prio') }}: <b>{{ stN(sh.lowItem, lang) }}</b> <span class="num-ltr">{{ sh.lowItem.pos }}%</span></div></span>
          <span class="go">{{ t('ex_more') }}</span>
        </a>
      </section>
    </template>

    <div class="excta"><v-btn color="primary" large depressed rounded class="sd-btn" @click="$emit('navigate', { name: 'indicators' })">{{ t('ex_cta') }}</v-btn></div>
  </div>
  <div v-else class="dload">{{ t('no_data') }}</div>
</template>
<script>
import { sdMixin } from '../store.js'
import { execModel } from '../lib/insights.js'
import { strategicHeadline, stN } from '../lib/strategic.js'
import { fmt, stC, pctHtml } from '../lib/format.js'
import { regionName } from '../lib/stats.js'
import SdKpiCard from '../components/KpiCard.vue'
import SdDeltaChip from '../components/DeltaChip.vue'
import SdStarPill from '../components/StarPill.vue'
import SdSparkLine from '../components/charts/SparkLine.vue'
import SdLineChart from '../components/charts/LineChart.vue'
import SdMeterRows from '../components/MeterRows.vue'
import SdInsightList from '../components/InsightList.vue'
export default {
  name: 'SdExecutiveView',
  components: { SdKpiCard, SdDeltaChip, SdStarPill, SdSparkLine, SdLineChart, SdMeterRows, SdInsightList },
  mixins: [sdMixin],
  computed: {
    m() { return this.D.satisfactionByYear ? execModel(this.D, this.lang, this.t) : null },
    sh() { return this.ST ? strategicHeadline(this.ST, this.lang, this.t) : null },
    trendSeries() {
      const v = {}, tips = {}
      this.m.yr.forEach((y) => { v[y.year] = y.satPct; tips[y.year] = `<b>${y.year}</b><br><span class="tt-k">${this.t('positive')}:</span> ${fmt(y.positive)}<br><span class="tt-k">${this.t('neu')}:</span> ${fmt(y.neutral)}<br><span class="tt-k">${this.t('negative')}:</span> ${fmt(y.negative)}<br><span class="tt-k">${this.t('m_sat')}:</span> ${pctHtml(y.satPct)}` })
      return [{ name: this.t('m_sat'), color: 'var(--sd-green-500)', v, tips }]
    },
    trendYears() { return this.m.yr.map((y) => String(y.year)) },
    regionRows() {
      const regs = this.m.regs; const pick = regs.length <= 6 ? regs : [...regs.slice(0, 3), null, ...regs.slice(-3)]
      return pick.map((r) => (r === null ? null : { key: r.region, name: regionName(r.region, this.lang), pct: r.satPct, rank: regs.indexOf(r) }))
    },
  },
  methods: { fmt, stC, stN },
}
</script>
